import { Action } from 'redux';
import {combineEpics, Epic, ofType} from 'redux-observable';
import { EMPTY, from, Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { changeLocation } from '../../actions/common';
import { RoutesPath } from '../../routes/index';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { VideoCreatorApiItemsResponse, VideoCreatorApiResponse } from '../api/typings';
import { VideoCreatorApiMethodExecutor } from '../api/VideoCreatorApi';
import { TemplateListItem } from '../VideoCreatorHelper/typings';
import { VideoCreatorHelpers } from '../VideoCreatorHelper/VideoCreatorHelper';
import {
    GET_VIDEO_CREATOR_MY_VIDEO_LIST,
    GetVideoCreatorMyVideoListAction,
    GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE,
    setVideoCreatorMyVideoList
} from '../VideoCreatorMyVideoPage/actions';

import {
    GET_VIDEO_CREATOR_TEMPLATE_LIST,
    GetVideoCreatorAction,
    GO_TO_VIDEO_CREATOR_MY_LIST_PAGE,
    setVideoCreatorTemplateList
} from './actions';

const getVideoCreatorTemplateListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GET_VIDEO_CREATOR_TEMPLATE_LIST),
        switchMap(
            (action: GetVideoCreatorAction): Observable<Action> => {
                return from(VideoCreatorHelpers.getTemplateList()).pipe(
                    mergeMap((list: TemplateListItem[]) => {
                        return of(setVideoCreatorTemplateList(list));
                    }),
                    catchError(() => EMPTY)
                );
            }
        )
    );
};

const getVideoCreatorMyVideoListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GET_VIDEO_CREATOR_MY_VIDEO_LIST),
        switchMap(
            (action: GetVideoCreatorMyVideoListAction): Observable<Action> => {
                const api = new VideoCreatorApiMethodExecutor();

                return from(api.getTemplateListData(action.userId)).pipe(
                    mergeMap((list: VideoCreatorApiItemsResponse<VideoCreatorApiResponse>) => {
                        return of(setVideoCreatorMyVideoList(list.items));
                    }),
                    catchError(() => EMPTY)
                );
            }
        )
    );
};

const goToVideoCreatorMyListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GO_TO_VIDEO_CREATOR_MY_LIST_PAGE),
        switchMap(
            (): Observable<Action> => {
                const {
                    commonData: { login }
                } = store$.value;

                return of(changeLocation(RoutesPath.videoCreatorMyVideo, { ulogin: login }, false));
            }
        )
    );
};

const goToVideoCreatorTemplatesListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE),
        switchMap(
            (): Observable<Action> => {
                const {
                    commonData: { login }
                } = store$.value;

                return of(changeLocation(RoutesPath.videoCreatorTemplatesList, { ulogin: login }, false));
            }
        )
    );
};

export const videoCreatorTemplatesListPageEpics = combineEpics(
    getVideoCreatorTemplateListEpic,
    getVideoCreatorMyVideoListEpic,
    goToVideoCreatorMyListEpic,
    goToVideoCreatorTemplatesListEpic
);
